import { AfterViewInit, Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[appTruncateText]',

  providers: [MatTooltip],
})
export class TruncateTextDirective implements AfterViewInit {
  @Input('appTruncateText') public text = '';
  @Input() public appTruncateMaxLength = 20;
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private tooltip = inject(MatTooltip);

  public ngAfterViewInit(): void {
    const text = this.text || this.el.nativeElement.innerText.trim();
    if (text?.length > this.appTruncateMaxLength) {
      const truncatedText = text?.substring(0, this.appTruncateMaxLength) + '...';
      this.renderer.setProperty(this.el.nativeElement, 'innerText', truncatedText);
      this.renderer.setStyle(this.el.nativeElement, 'cursor', 'help');
      this.tooltip.message = text;
      this.tooltip.position = 'above';
      this.tooltip.showDelay = 500;
      this.tooltip.hideDelay = 200;
      this.tooltip.disabled = false;
      this.tooltip.ngAfterViewInit();
    }
  }
}
